import { ProductSkuStore, PRODUCT_SKU_STORE } from 'store'

export type ProductSkusTableProps = {
  [PRODUCT_SKU_STORE]?: ProductSkuStore
}

export const skuTableWidths = {
  sku: 400,
  price: 322,
  stock: 300,
  sold: 350,
  revenue: 380
}
